import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Dropdown,Select, Radio, Row, Space,DatePicker, message, Modal } from 'antd';

import { BASE_URL,AddStaff, UploadFile, FetchDepartment, FetchDesignation, FetchShifts, FetchLocation, STAFF_ROLE, UpdateStaff } from "../../utils/constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { CameraOutlined } from "@ant-design/icons";
import moment from "moment";
import { useSelector } from "react-redux";
import dayjs from "dayjs";

const EditStaffForm = ({ open, onCancel,isAttendanceHead,isEmployeeHead, onAddOrUpdate, initialValue }) => {
  const userInfo = useSelector((state) => state.signUp.signUpDetails);
console.log('initialValuess',initialValue)
// const editValue = [initialValue]
    const [departmentList, setDepartmentList] = useState([]);
    const [departmentFullList, setDepartmentFullList] = useState([]);
    const [subDepartmentList, setSubDepartmentList] = useState([]);
    const [designationList, setDesignationList] = useState([]);
    const [shiftList, setShiftList] = useState([]);
    const [locationList, setLocationList] = useState([]);
    const [staffDetails, setStaffDetails] = useState([]);
    const [firstName, setFirstName] = useState("");
    const [staffNumber, setStaffNumber] = useState("");
    const [lastName, setLastName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [permanentAddress, setPermanentAddress] = useState("");
    const [currentAddress, setCurrentAddress] = useState("");
    const [gender, setGender] = useState("");
    const [martialStatus, setMartialStatus] = useState("");
    const [dob, setDob] = useState(null);
    const [doj, setDoj] = useState(null);
    const [designation, setDesignation] = useState("");
    const [department, setDepartment] = useState("");
    const [subDepartmentId, setSubDepartment] = useState("");
    const [shift, setShift] = useState("");
    const [mainSite, setMainSite] = useState([]);
    const [weeklyOff, setWeaklyOff] = useState([]);
    const [isEditModeEnables, setIsEditModeEnables] = useState(null);
    const [logo, setLogo] = useState(null);
    const [staffTitle, setStaffTitle] = useState("Staff 1");
    const [genderOptions, setGenderOptions] = useState([
        { value: 'male', label: 'male' },
        { value: 'female', label: 'female' },
        { value: 'other', label: 'other' },
        
      ]);
    const [martialStatusOptions, setMartialStatusOptions] = useState([
        { value: 'single', label: 'single' },
        { value: 'married', label: 'married' }        
      ]);
 
    const [weekOffOptions, setWeekOffOptions] = useState([
        { value: 0, label: 'Sunday' },
        { value: 1, label: 'Monday' },
        { value: 2, label: 'Tuesday' },
        { value: 3, label: 'Wednesday' },
        { value: 4, label: 'Thursday' },
        { value: 5, label: 'Friday' },
        { value: 6, label: 'Saturday' },
        
      ]);
      const [initialValues, setInitialValue] = useState([]);

      useEffect(() => {
        const editValue = [initialValue]
        setInitialValue(editValue?.map(staffItem => {
        // Assuming mainSite is an array property in each staffItem
        const locationOption = staffItem?.mainSite?.map(item => ( item.locationId
       ));
       
    const subDepartmentOption =staffItem?.subDepartmentId?.subDeptId
    const departmentOption =staffItem?.department?.departmentId
    const subDepartments = staffItem?.department?.subDepartments?.map((subDept) => ({
    value: subDept.subDeptId,
    label: subDept.subDeptName,
    }));
    console.log('subDepartments',subDepartments)
    setSubDepartmentList(subDepartments);
    
    const designationOption = staffItem?.designation?.designationId
    
    const shiftOption = staffItem?.shift?.shiftId
      
        // Update the mainSite property with the transformed data
        return {
          ...staffItem,
          mainSite: locationOption,
          department: departmentOption,
          subDepartmentId: subDepartmentOption,
          designation: designationOption,
          shift: shiftOption,
        };
      }));
    },[initialValue,open])

      useEffect(() => {

        console.log('initialValues',initialValues)
        if(initialValues && initialValues.length > 0){
            console.log('initialValues?.address',initialValues[0])
            setLogo(initialValues[0]?.faceRegisterUrl)
            setFirstName(initialValues[0]?.firstName)
            setLastName(initialValues[0]?.lastName)
            setGender(initialValues[0]?.gender)
            setPhoneNumber(initialValues[0]?.phoneNumber)
            setPermanentAddress(initialValues[0]?.permanentAddress)
            setCurrentAddress(initialValues[0]?.currentAddress)
            setMartialStatus(initialValues[0]?.martialStatus)
            setDob(dayjs(initialValues[0]?.dob))
            setDoj(dayjs(initialValues[0]?.doj))
            setDesignation(initialValues[0]?.designation)
            setDepartment(initialValues[0]?.department)
            setSubDepartment(initialValues[0]?.subDepartmentId)
            setShift(initialValues[0]?.shift)
            setMainSite(initialValues[0]?.mainSite)
            setWeaklyOff(initialValues[0]?.weeklyOff)
        }
            },[open])
    const addFinalStaff = () => {
      // if (!logo  ) {
      //   // Display an error message or take appropriate action
      //       toast.error("Please add Logo.", {
      //           position: toast.POSITION.TOP_RIGHT,
      //         });
      //       return;
      //     }
        if (!firstName ) {
            // Display an error message or take appropriate action
            toast.error("Please fill First Name.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            return;
          }
        if ( !lastName ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Last Name.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }
          if ( !gender  ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Gender.", {
              position: toast.POSITION.TOP_RIGHT,
            });
            return;
          }
          if ( !phoneNumber ) {
            // Display an error message or take appropriate action
            toast.error("Please fill Phone Number.", {
              position: toast.POSITION.TOP_RIGHT,
              });
              return;
            }
            if ( !designation  ) {
                // Display an error message or take appropriate action
                toast.error("Please fill Designation.", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                return;
              }
            if ( !department  ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Department.", {
                position: toast.POSITION.TOP_RIGHT,
              });
            return;
          }
        // if ( !subDepartmentId) {
        //     // Display an error message or take appropriate action
        //     toast.error("Please fill Sub DepartmentId.", {
        //       position: toast.POSITION.TOP_RIGHT,
        //     });
        //     return;
        //   }
          if ( !shift  ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Shift.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              return;
            }
          if (  mainSite.length == 0 ) {
              // Display an error message or take appropriate action
              toast.error("Please fill Main Site.", {
                  position: toast.POSITION.TOP_RIGHT,
                });
              return;
            }
        console.log('nextstaffDetails',staffDetails)
        const token = localStorage.getItem('authToken');
        
        const dataToSend = {
            _id: initialValues[0]?._id,
            ...(logo && { logo }),
    ...(firstName && { firstName }),
    ...(lastName && { lastName }),
    ...(phoneNumber && { phoneNumber }),
    ...(gender && { gender }),
    ...(martialStatus && { martialStatus }),
    ...(dob && { dob }),
    ...(doj && { doj }),
    ...(currentAddress && { currentAddress }),
    ...(permanentAddress && { permanentAddress }),
    ...(department && { department }),
    ...(subDepartmentId && { subDepartmentId }),
    ...(designation && { designation }),
    ...(shift && { shift }),
    ...(mainSite && mainSite.length > 0 && { mainSite }),
    ...(weeklyOff && weeklyOff.length > 0 && { weeklyOff }),
          
        };
        // const storedDataString = localStorage.getItem("roles");
         
        
        console.log('dataToSend',dataToSend)
        // const parseToken = JSON.parse(token) || {};
      const fetchData = async () => {
        const response = await fetch(`${BASE_URL}/${UpdateStaff}`, {
          method: "POST",
          headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `${token}`,
                    
                  },
          body: JSON.stringify(dataToSend),
        });
    
        console.log('CompanyData')
        if (response.ok) {
          const data = await response.json();
    
          console.log('staffDetail',data)
          setLogo(null)
          setFirstName("")
          setLastName("")
          setPhoneNumber("")
          setGender("")
          setMartialStatus("")
          setDob(null)
          setDoj(null)
          setCurrentAddress("")
          setPermanentAddress("")
          setDepartment("")
          setSubDepartment("")
          setDesignation("")
          setShift("")
          setMainSite([])
          setWeaklyOff([])
          onCancel()
          
        } else {
          const data = await response.json();
          console.log('staffDetail',data)
          console.log('data?.data?.index',data?.data?.index)
         
  
            toast.error(data.errorMessage, {
              position: toast.POSITION.TOP_RIGHT,
            });
          
           
       }
       };
    
        fetchData();
       
      }
      const handleStaffNumber = useCallback((value) => {
          console.log('value',value.target.value)
          setStaffNumber(() => value.target.value);
        }, []);
      const handleFirstName = useCallback((value) => {
          console.log('value',value.target.value)
          setFirstName(() => value.target.value);
        }, []);
      const handleLastName = useCallback((value) => {
          console.log('setLastName',value.target.value)
          setLastName(() => value.target.value);
        }, []);
      const handlePhoneNumber = useCallback((value) => {
          console.log('PhoneNumber',value.target.value)
          setPhoneNumber(() => value.target.value);
        }, []);
      const handlePermanentAddress = useCallback((value) => {
          console.log('PermanentAddress',value.target.value)
          setPermanentAddress(() => value.target.value);
        }, []);
      const handleCurrentAddress = useCallback((value) => {
          console.log('CurrentAddress',value.target.value)
          setCurrentAddress(() => value.target.value);
        }, []);
        const handleGender = useCallback((value) => {
          console.log('value',value)
          setGender(() => value);
        }, []);
        const handleMaritalStatus = useCallback((value) => {
          console.log('value',value)
          setMartialStatus(() => value);
        }, []);
        const handleDobChange = (date, dateString) => {
          console.log('Selected DOB:', dateString);
          console.log(' DOB:', date);
          setDob(date);
        };
        const handleDojChange = (date, dateString) => {
          console.log('Selected DOj:', dateString);
          console.log(' DOj:', date);
          setDoj(date);
        };
        const handleDesignation = useCallback((value) => {
          console.log('value',value)
          setDesignation(() => value);
        }, []);
        const handleWeekOff = useCallback((value) => {
          console.log('value',value)
          setWeaklyOff(() => value);
        }, []);      
        const handleDepartment = (value) => {
          console.log('value',value)
          console.log('departmentList',departmentFullList)
          const selectedDepartment = departmentFullList.find((dept) => dept.departmentId === value);
  console.log('selectedDepartment',selectedDepartment)
          // Update subDepartmentList based on the selected department
          if (selectedDepartment && selectedDepartment.subDepartments) {
            const subDepartments = selectedDepartment.subDepartments?.map((subDept) => ({
              value: subDept.subDeptId,
              label: subDept.subDeptName,
            }));
            setSubDepartmentList(subDepartments);
            setSubDepartment('');
          } else {
            // If no subDepartments found, set subDepartmentList as empty array
            setSubDepartmentList([]);
          }
          setDepartment( value);
        };
        const handleSubDepartment = useCallback((value) => {
          console.log('value',value)
          setSubDepartment(() => value);
        }, []);
        const handleShift = useCallback((value) => {
          console.log('value',value)
          setShift(() => value);
        }, []);
        const handleMainSite = useCallback((value) => {
          console.log('value',value)
          setMainSite(() => value);
        }, []);
        
        
        // const progressIdd = useUID();
  
        const handleUploadLogo = (e) => {
          const file = e.target.files[0];
          console.log('file',file)
          // console.log('progressIdd',progressIdd)
          if (file) {
            // Check if the file type is an image
            if (file.type.startsWith("image/")) {
              const fetchData = async () => {
  
                const formData = new FormData();
                formData.append("files", file);   
                formData.append("folder", 'profilePhotos');   
                // formData.append("progressId", progressIdd);   
                
              
              const response = await fetch(`${BASE_URL}/${UploadFile}`, {
                method: "POST",
                
                body: formData,
              });
              
              if (response.ok) {
                const data = await response.json();
                console.log('data',data)
                setLogo(data?.data[0]);
                // setLogo(file);
                
              } else {
                const data = await response.json();
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                console.log('errdata',data)
                   
               };
               
              
            };
            fetchData();
            } else {
              alert("Select image only.");
            }
          }
        };
        const disabledDate = current => {
            // Disable future dates
            return current && current > moment().endOf('day');
          };

          useEffect(() => {

            getAllDropdownList();
          }, []);
          const getAllDropdownList = async () =>{
            const token = localStorage.getItem('authToken');
          
            const fetchData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDepartment}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('departmentt',activeLocations)
                 setDepartmentFullList(activeLocations)
                const departmentOption = activeLocations?.map((item) => ({
                  value: item.departmentId,
                  label: item.departmentName,
                }));
                console.log('departmentOption',departmentOption)
                setDepartmentList(departmentOption)
                
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchDesignationData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchDesignation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('designation',activeLocations)
                const designationOption = activeLocations?.map((item) => ({
                  value: item.designationId,
                  label: item.designationName,
                }));
                console.log('designationOption',designationOption)
                setDesignationList(designationOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('departmenterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchShiftData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchShifts}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('shift',activeLocations)
                const shiftOption = activeLocations?.map((item) => ({
                  value: item.shiftId,
                  label: item.shiftFullName,
                }));
                console.log('shiftOption',shiftOption)
                setShiftList(shiftOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('shifterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            const fetchLocationData = async () => {
              const response = await fetch(`${BASE_URL}/${FetchLocation}`, {
                method: "POST",
                 headers: {
                          'Content-Type': 'application/json',
                          'Authorization': `${token}`,
                          
                        },
                body: JSON.stringify({isDeleted:false}),
              });
              
              if (response.ok) {
                const data = await response.json();
                const activeLocations = data.data.filter(item => item.isActive);
        
                console.log('shift',activeLocations)
                const locationOption = activeLocations?.map((item) => ({
                  value: item.locationId,
                  label: item.locationName1,
                }));
                console.log('locationOption',locationOption)
                setLocationList(locationOption)
          
                // setLocations(tableshowData);
              
              } else {
                const data = await response.json();
                console.log('shifterr',data)
                toast.error(data.errorMessage, {
                  position: toast.POSITION.TOP_RIGHT,
                });
                
              }
            };
            await fetchData();
            await fetchDesignationData();
            await fetchShiftData();
            await fetchLocationData();
          }
  return (
    <Modal
      title="Add Staff"
      open={open}
      okButtonProps={{ style: { background: "grey" } }}
      onCancel={onCancel}
      footer={null}
      className="min-w-[750px] [&_.ant-modal-title]:text-center [&_.ant-modal-title]:text-[20px]"
    >
     <ToastContainer position="top-right" autoClose={5000} />

      <div className=" mt-2">
        <p className="text-base text-[#4B8AEB] font-sbold px-3 mb-1">Personal Details</p>
        <div className="bg-[#EDF3FD] rounded-[25px] p-3 mb-3">
          <Row>
            {/* <Col lg={3}> */}
             <div className="mb-4 mx-auto">
              <div className="text-center mt-1 mb-2">
                <label className="w-[58px] h-[58px] bg-[#d2dfe7] flex items-center justify-center mx-auto rounded-full cursor-pointer my-0">
                  {!logo && <CameraOutlined className="text-[#4B8AEB]" />}
                  <input
                    type="file"
                    className="hidden"
                    accept="image/*"
                    onChange={handleUploadLogo}
                  />
                  {logo && (
                    <img
                      src={logo}
                      alt="company_logo"
                      className="overflow-hidden rounded-full w-full h-full object-cover"
                    />
                  )}
                </label>
                <span className="font-sbold text-sm">Profile<span className='text-red-500'></span></span>
              </div>
              <p className="text-[red] text-xs">This photo will used to mark attendance of the employee</p>
              </div>
              <div className="w-full grid grid-cols-12 gap-x-3 gap-y-4">
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">First Name<span className='text-red-500'>*</span></label>
                  <input
                    className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none"
                    type="text"
                    value={firstName}
                    onChange={handleFirstName}
                  />
                </div> 
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                    <label htmlFor="shift" className="mb-1 text-sm">Last Name<span className='text-red-500'>*</span></label>
                      <input
                        className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none"
                        type="text"
                        value={lastName}
                        onChange={handleLastName}
                      />
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Gender<span className='text-red-500'>*</span></label>
                  <select
                    required
                    onChange={(e) => handleGender(e.target.value)}
                    value={gender}
                    className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${gender === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
                  >
                    <option value="" disabled selected>
                      Gender
                    </option>
                    {genderOptions.map((item, index) => {
                      return (
                        <option
                          value={item.value}
                          className="text-[#6C94B4]"
                          key={index}
                          onClick={() => handleGender(item.value)}
                        >
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Phone number<span className='text-red-500'>*</span></label>
                  <input
                    className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none"
                    type="tel"
                    value={phoneNumber}
                    onChange={handlePhoneNumber}
                    maxLength={10}
                  />
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Martial Status</label>
                  <select
                    required
                    onChange={(e) => handleMaritalStatus(e.target.value)}
                    value={martialStatus}
                    className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${martialStatus === "" ? "staffAttendForm placeholder" : "staffAttendForm"}`}
                  >
                    <option value="" disabled selected>
                      Marital status
                    </option>
                    {martialStatusOptions.map((item, index) => {
                      return (
                        <option
                          value={item.value}
                          className="text-[#6C94B4]"
                          key={index}
                          onClick={() => handleMaritalStatus(item.value)}
                        >
                          {item.label}
                        </option>
                      );
                    })}
                  </select>
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Permanent Address</label>
                  <input
                    className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none"
                    type="text"
                    value={permanentAddress}
                    onChange={handlePermanentAddress}
                  />
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Current Address</label>
                  <input
                    className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none"
                    type="text"
                    value={currentAddress}
                    onChange={handleCurrentAddress}
                  />
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Date of Birth</label>
                      <DatePicker
                        className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none border-none shadow-none"
                        format="YYYY-MM-DD"
                        onChange={handleDobChange}
                        value={dob ?  dob : null}
                        disabledDate={disabledDate}
                      />
                
                </div>
                <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
                  <label htmlFor="shift" className="mb-1 text-sm">Date of Joining</label>
                      <DatePicker
                        className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none border-none shadow-none"
                        format="YYYY-MM-DD"
                        onChange={handleDojChange}
                        value={doj ?  doj : null}
                        disabledDate={disabledDate}
                      />
                
                </div>
              </div>
             
            {/* </Col> */}
          </Row>
        </div>
        <p className="text-base text-[#4B8AEB] font-sbold px-3 mb-1">Work Details</p>
        <div className="bg-[#EDF3FD] rounded-[25px] p-3 mb-3">
          <div className="w-full grid grid-cols-12 gap-x-3 gap-y-4">
            <div className="col-span-4">
              <label htmlFor="shift" className="mb-1 text-sm">Designation<span className='text-red-500'>*</span>:</label>
              <select
                className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${designation === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
                required
                onChange={(e) => handleDesignation(e.target.value)}
                value={designation}
              >
                <option value="" disabled selected>
                  Designation
                </option>
                {designationList.map((item, index) => {
                  return (
                    <option
                      value={item.value}
                      className="text-[#6C94B4]"
                      key={index}
                      onClick={() => handleDesignation(item.value)}
                    >
                      {item.label}
                    </option>
                  );
                })}
              </select>  
            </div>
            <div className="col-span-4">
              <label htmlFor="department" className="mb-1 text-sm">Department<span className='text-red-500'>*</span>:</label>
              <select
                required
                onChange={(e) => handleDepartment(e.target.value)}
                value={department}
                className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${department === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
              >
                <option value="" disabled selected>
                  Department
                </option>
                {departmentList.map((item, index) => {
                  return (
                    <option
                      value={item.value}
                      className="text-[#6C94B4]"
                      key={index}
                      onClick={() => handleDepartment(item.value)}
                    >
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-span-4">
              <label htmlFor="shift" className="mb-1 text-sm">Sub Department<span className='text-red-500'>*</span>:</label>
              <select
                required
                onChange={(e) => handleSubDepartment(e.target.value)}
                value={subDepartmentId}
                className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${
                  subDepartmentId === "" ? "placeholder staffAttendForm" : "staffAttendForm"
                }`}
              >
                <option value="" disabled selected>
                  Sub Department
                </option>
                {subDepartmentList && subDepartmentList.length > 0 && subDepartmentList.map((item, index) => {
                  return (
                    <option
                      value={item.value}
                      className="text-[#6C94B4]"
                      key={index}
                      onClick={() => handleSubDepartment(item.value)}
                    >
                      {item.label}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-span-12 flex flex-col">
              <label htmlFor="shift" className="mb-1 text-sm">Weekly Off:</label>
              <Select
                mode="multiple"
                allowClear
                className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none multiSelecStaffAttend [&_.ant-select-selector]:!bg-transparent [&_.ant-select-selector]:!border-none [&_.ant-select-selection-item]:!bg-[#EDF3FD] [&_.ant-select-selector]:!shadow-none"
                maxTagCount={2}
                // defaultValue={weeklyOff.length > 0 ? [weeklyOff] : [] }
                value={weeklyOff}
                onChange={handleWeekOff}
                options={weekOffOptions}
              />
            </div>
          </div>
        </div>
        <p className="text-base text-[#4B8AEB] font-sbold px-3 mb-1">Optional Details</p>
        <div className="bg-[#EDF3FD] rounded-[25px] p-3">
          <div className="grid grid-cols-12 gap-3">
            <div className="col-span-4" style={{ display: "flex", flexDirection: "column" }}>
              <label htmlFor="shift" className="mb-1 text-sm">Shift<span className='text-red-500'>*</span>:</label>
              <select
                required
                onChange={(e) => handleShift(e.target.value)}
                value={shift}
                className={`bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none ${shift === "" ? "placeholder staffAttendForm" : "staffAttendForm"}`}
              >
                <option value="" disabled selected>Shift</option>
                  {shiftList.map((item, index) => {
                    return (
                      <option
                        value={item.value}
                        className="text-[#6C94B4]"
                        key={index}
                        onClick={() => handleShift(item.value)}
                      >
                        {item.label}
                      </option>
                    );
                  })}
              </select>
            </div>
            <div className="col-span-8" style={{ display: "flex", flexDirection: "column" }}>
              <label htmlFor="mainSite" className="mb-1 text-sm">Main Site<span className='text-red-500'>*</span>:</label>
              <Select
                mode="multiple"
                className="bg-[#CDDEF9] rounded-full h-[45px] !px-4 !outline-none multiSelecStaffAttend [&_.ant-select-selector]:!bg-transparent [&_.ant-select-selector]:!border-none [&_.ant-select-selection-item]:!bg-[#EDF3FD] [&_.ant-select-selector]:!shadow-none"
                allowClear
                maxTagCount={2}
                onChange={handleMainSite}
                value={mainSite}
                options={locationList}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="text-center mt-4">
                <Button
                  className="!border-[#4B8AEB] text-[#ffffff] bg-[#4B8AEB] hover:bg-[#fff] hover:!bg-transparent !outline-none hover:!text-[#4B8AEB] rounded-full py-2 px-5 h-auto !text-sm"
                  onClick={addFinalStaff}
                >
                  <span className="font-sbold">+Update Staff</span>
                </Button>
              </div>
    </Modal>
  );
};

export default EditStaffForm;
